<!-- 生产线处理 -->
<template>
  <div class="client_form workOrderTem">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px" class="demo-ruleForm">
      <el-form-item :label="$t('workOrder.finished_testing')" prop="finishedTest">
        <el-radio-group v-model="form.finishedTest">
          <template v-for="item in testOptions">
            <el-radio :label="item.value">{{ item.label }}</el-radio>
          </template>

        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('workOrder.aging_test')" prop="agingTest">
        <el-radio-group v-model="form.agingTest">
          <template v-for="item in testOptions">
            <el-radio :label="item.value">{{ item.label }}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('workOrder.recheck')" prop="recheck">
        <el-radio-group v-model="form.recheck">
          <template v-for="item in testOptions">
            <el-radio :label="item.value">{{ item.label }}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('workOrder.packaging_storage')" prop="isPack">
        <el-radio-group v-model="form.isPack">
          <el-radio :label="true">{{ $t('workOrder.yes') }}</el-radio>
          <el-radio :label="false">{{ $t('workOrder.no') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('workOrder.suggest')" prop="description">
        <el-input v-model="form.description" type="textarea" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.handler')" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.processing_time')" prop="handleTime">
        <el-date-picker v-model="form.handleTime" type="datetime" :clearable="false" default-time="14:00:00" value-format="timestamp" style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.state_flow')" prop="status">
        <el-select v-model="form.status" style="width: 100%;">
          <template v-for="item in statusOptions">
            <el-option :label="$t('workOrder.'+ item.label)" :value="item.value" />
          </template>
        </el-select>
      </el-form-item>

      <el-form-item class="btnWarp">
        <el-button type="primary" :disabled="subDisabled" @click="submitForm('ruleForm')">{{ isEdit?$t('workOrder.Revise'): $t('workOrder.save') }}</el-button>
        <el-button @click="clickCancel('quxiao')">{{ $t('workOrder.cancel') }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { isObjectValueEqual } from '@/utils'
export default {
  components: {},
  props: {
    raw: {}
  },
  data() {
    return {
      attrArr: ['agingTest', 'description', 'finishedTest', 'handleTime', 'isPack', 'name', 'recheck', 'status'], // 需要对比的属性
      initObj: {}, // 判断是否有改变项--初始化时的值
      newObj: {}, // 判断是否有改变项--最新的值
      subDisabled: false,
      form: {
        agingTest: 1,
        description: '',
        finishedTest: 1,
        handleTime: new Date().getTime(),
        isPack: false,
        name: '',
        recheck: 1,
        status: ''
      },

      statusOptions: [
        { label: 'pmc_handling', value: 6 },
        { label: 'quality_inspection', value: 3 },
        { label: 'repair_processing', value: 4 }
      ],
      user: [],
      isEdit: false// 修改
    }
  },
  computed: {
    testOptions() {
      return [
        { label: this.$t('workOrder.not_performed'), value: '1' },
        { label: this.$t('workOrder.pass'), value: '2' },
        { label: this.$t('workOrder.fail'), value: '3' }
      ]
    },
    rules() {
      return {
        measure: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        scope: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        problemType: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        handleTime: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    raw: {
      deep: true,
      handler(obj) {
        this.initForm(obj)
      }
    }
  },
  mounted() {
    this.initForm(this.raw)
  },
  methods: {
    initForm(raw) {
      console.log('生产线处理：raw', raw)
      this.isEdit = false
      if (raw.step5) {
        this.form = JSON.parse(raw.step5)
        this.isEdit = true
      }
      var configList = this.$storage.get('configList') || []
      configList.forEach((v, i) => {
        if (v.key == 'user') {
          this.user = v.valueList || []
        }
      })
      this.initObj = this.getObjFn(this.form)
      console.log('initForm:this.form', this.form)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.user && this.form.name != this.user[3]) {
          //   this.$message({
          //     type: 'error',
          //     message: this.$t('workOrder.notPermission')// '提交失败，该处理人无权限，请联系部门负责人'
          //   })
          //   return
          // }
          this.subDisabled = true
          setTimeout(() => {
            this.subDisabled = false
          }, 2000)

          const form = {}
          for (const key in this.raw) {
            if (Object.hasOwnProperty.call(this.raw, key)) {
              const element = this.raw[key]
              form[key] = element
            }
          }
          form.status = this.form.status
          form.step5 = JSON.stringify(this.form)
          this.$emit('save', form)
          console.log(form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    clickCancel(val) {
      this.newObj = this.getObjFn(this.form)
      this.$emit('back', this.initObj, this.newObj, val)
    },
    getObjFn(obj) {
      var newObj = {}
      this.attrArr.forEach(v => {
        newObj[v] = obj[v]
      })
      return newObj
    }
  }
}
</script>

<style lang='scss' scoped>
.client_form {
  width: 700px;
  margin: 20px auto;
}
</style>
